import { motion } from "framer-motion";

const Spinner = ({ size = 24 }) => {
  return (
    <div className="flex items-center justify-center">
      <motion.div
        style={{ width: size, height: size }}
        className="border-2 border-[#B8977F] border-t-transparent rounded-full"
        animate={{ rotate: 360 }}
        transition={{
          repeat: Infinity,
          duration: 0.8,
          ease: "linear",
        }}
      />
    </div>
  );
};

export default Spinner;